/* ============================================================
   Llorrea — knoppen die naar een sectie scrollen
   Gebruikt scrollIntoView, zodat het ook werkt als het thema
   binnen een container scrolt in plaats van het venster.
   ============================================================ */
(function(){

  function findTarget(sel, from){
    var el = null;
    var parts = (sel || '').split(',');

    for(var i = 0; i < parts.length; i++){
      var p = parts[i].trim();
      if(!p) continue;
      try { el = document.querySelector(p); } catch(err) { el = null; }
      if(el && el !== from && !el.contains(from)) return el;
    }

    el = document.querySelector('.llorrea-review-carousel, [id^="llrc-"]');
    if(el && !el.contains(from)) return el;

    var guesses = document.querySelectorAll('[class*="review" i],[id*="review" i]');
    for(var j = 0; j < guesses.length; j++){
      if(guesses[j] !== from && !guesses[j].contains(from)) return guesses[j];
    }
    return null;
  }

  function go(btn){
    var target = findTarget(btn.getAttribute('data-llo-scrollto'), btn);
    if(!target) return;

    var offset = parseInt(btn.getAttribute('data-llo-offset'), 10) || 0;
    if(offset) target.style.scrollMarginTop = offset + 'px';

    /* 1. de betrouwbaarste manier: laat de browser zelf de juiste
          scrollcontainer kiezen */
    if(typeof target.scrollIntoView === 'function'){
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        return;
      } catch(err){
        try { target.scrollIntoView(true); return; } catch(e2){}
      }
    }

    /* 2. vangnet: het venster verschuiven */
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    if(top < 0) top = 0;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch(err){ window.scrollTo(0, top); }
  }

  if(!window.lloScrollDelegated){
    window.lloScrollDelegated = true;
    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('[data-llo-scrollto]') : null;
      if(!btn) return;
      e.preventDefault();
      go(btn);
    }, true);
  }

  function bind(){
    var btns = document.querySelectorAll('[data-llo-scrollto]');
    for(var i = 0; i < btns.length; i++){
      if(btns[i].dataset.lloBound === '1') continue;
      btns[i].dataset.lloBound = '1';
      btns[i].addEventListener('click', function(e){
        e.preventDefault();
        go(this);
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.addEventListener('load', bind);
  document.addEventListener('shopify:section:load', function(){ setTimeout(bind, 60); });
})();
